<template>
  <div class="section-ghraph-data-content-row-col">
    <div class="small-graph">
      <div class="small-graph-desc">
        {{ range }}
      </div>
      <div class="small-graph-bar-wrap">
        <div class="small-graph-bar-counter">
          <template v-if="percent !== 0">{{
            percent | numeral("0")
          }}%</template>
        </div>
        <div class="small-graph-bar">
          <div
            v-if="percent !== 0"
            class="small-graph-bar-fill"
            v-bind:style="{ width: percent + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RoeCompensationSegmentBar",
  props: {
    range: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(["compensationSegments"]),
    percent() {
      let segment = this.compensationSegments.find(segment => {
        return segment.wage_range === this.range;
      });
      return segment ? segment.percentage : 0;
    }
  }
};
</script>
